import React from "react";
import { Container, Logo } from "./styled";
import logo from "./modefinance_logo.png";
import { FormattedMessage } from "react-intl";
export const ModefinancePolicyMessage = () => {
    return (
        <Container>
            <Logo src={logo} alt="modefinance logo" />
            <FormattedMessage
                id="policy.message"
                values={{
                    a: (chunks: any) => (
                        <a
                            href="https://privacy.modefinance.com/it"
                            target="_blank"
                            rel="noreferrer"
                        >
                            {chunks}
                        </a>
                    ),
                }}
            />
        </Container>
    );
};
